import React from 'react'
import isUndefined from 'lodash/isUndefined'
import { getProfilePhoto } from '../../../../helpers/image'
import { blankValue } from '../../../../helpers/cleanup'
import Apartment from '../../../../assets/svgs/Apartment'
import Area from '../../../../assets/svgs/details/area'
import Garage from '../../../../assets/svgs/details/garage'
import Bed from '../../../../assets/svgs/details/bed'
import Shower from '../../../../assets/svgs/details/shower'
import User from '../../../../assets/user.png'
import HomeBackground from '../../../../assets/home-background.png'
import COLORS from '../../../../styles/colors'

import './style.scss'

const InviteAnnoucementCard = ({
  propertyImage,
  typeHome,
  area,
  bathrooms,
  rooms,
  garage,
  landLordImage,
  landLordName,
  state,
  neighbourhood,
  rent,
  condo,
  other,
}) => (
  <div className='share-card'>
    <img
      className='share-card_image'
      src={isUndefined(propertyImage) ? HomeBackground : propertyImage}
      alt='card'
    />
    <div className='share-card_container_info'>
      <img
        className='share-card_user_image'
        src={isUndefined(landLordImage) ? getProfilePhoto(landLordImage, landLordName) : User}
        alt='landlord'
      />
      <div className='share-card_info'>
        <div className='share-card_info_content'>
          <div className='share-card_info_label'>
            {neighbourhood ? `${neighbourhood}, ${state}` : 'Endereço'}
          </div>
          <div className='share-card_info_text'>R$ {blankValue(rent)}</div>
        </div>
        <div className='share-card_info_content'>
          <div className='share-card_info_label'>Condominio & Outros</div>
          <div className='share-card_info_text'>R$ {blankValue(condo + other)}</div>
        </div>
      </div>
    </div>
    <div className='share-card_container'>
      <div className='share-details'>
        <div className='share-details_values'>
          <Apartment color={COLORS.gray} />
          <div className='share-details_box'>
            <div className='share-details_label'>Tipo:</div>
            <div className='share-details_text'>{blankValue(typeHome)}</div>
          </div>
        </div>
        <div className='share-details_values'>
          <Area color={COLORS.gray} />
          <div className='share-details_box'>
            <div className='share-details_label'>Área:</div>
            <div className='share-details_text'>{blankValue(area)}m²</div>
          </div>
        </div>
        <div className='share-details_values'>
          <Shower color={COLORS.gray} />
          <div className='share-details_box'>
            <div className='share-details_label'>Banheiros:</div>
            <div className='share-details_text'>{blankValue(bathrooms)}</div>
          </div>
        </div>
      </div>
      <div className='details share-details_lateral_space'>
        <div className='share-details_values'>
          <Bed color={COLORS.gray} />
          <div className='share-details_box'>
            <div className='share-details_label'>Quartos:</div>
            <div className='share-details_text'>{blankValue(rooms)}</div>
          </div>
        </div>
        <div className='share-details_values'>
          <Garage color={COLORS.gray} />
          <div className='share-details_box'>
            <div className='share-details_label'>Vagas:</div>
            <div className='share-details_text'>{blankValue(garage)}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

// TODO: use ts
// InviteAnnoucementCard.propType = {
//   propertyImage: PropTypes.string,
//   typeHome: PropTypes.string,
//   area: PropTypes.string,
//   bathrooms: PropTypes.string,
//   rooms: PropTypes.string,
//   garage: PropTypes.string,
//   landLordImage: PropTypes.object,
//   landLordName: PropTypes.string,
//   state: PropTypes.string,
//   neighbourhood: PropTypes.number,
//   rent: PropTypes.number,
//   condo: PropTypes.number,
//   other: PropTypes.number,
// }

export default InviteAnnoucementCard
